import React, { useEffect } from "react";
import { Form, Input, Button, Card, Row, Col, Space, message, Tag, Alert } from "antd";
import { UserOutlined, MailOutlined, KeyOutlined, LockOutlined, CopyOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import "./BasicInfoTab.css";
import { use } from "react";
import { THEME_PALLETE } from "../../../Theme";
import ChangePasswordModal from "../ChangePasswordModal";
import PermissionManager from "../../../managers/PermissionManager";

const BasicInfoTab = ({ userData, setUserData, parentProps, onContinue, onDataChange = () => { }, onStepComplete = () => { } }) => {
  const [form] = Form.useForm();
  const [formData, setFormData] = React.useState({ isGuest: undefined });
  const [showUpdatePassword, setShowUpdatePassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleContinue = async () => {
    console.log("Handling continue with formData:", formData);
    try {
      const values = await form.validateFields(); // ✅ Validate first
      console.log("Form Values:", values);
      // onDataChange(values); // pass back to parent if needed
      // onContinue(); // move to next tab

      checkUserExists(values).then(() => {

        onDataChange(values);
        onStepComplete();
      });
    } catch (errorInfo) {
      console.log("User check failed:", errorInfo);
    }
  };

  useEffect(() => {
    onDataChange(formData);
  }, [formData]);

  useEffect(() => {
    if (!userData) {
      return;
    }
    setFormData({ firstname: userData.firstname, lastname: userData.lastname, email: userData.email, username: userData.username } || {});
  }, [userData]);

  useEffect(() => {
    console.log("BasicInfoTab mounted " + JSON.stringify(formData));
  }, []);

  const checkUserExists = (userD) => {

    return new Promise((resolve, reject) => {
      if (!parentProps)
        reject();

      const { requestServerPost, usermaintoken } = parentProps;

      const params = new FormData();
      const { username, email } = userD;

      params.append("username", username)
      params.append("email", email)
      params.append("isguest", formData.isGuest ? 1 : 0)


      setLoading(true)

      requestServerPost("check_user", params, {}, (response) => {
        console.log("checkUserExists " + JSON.stringify(response))

        setLoading(false);

        if (!response.data)
          reject("User check failed.");

        if (response.data?.status == "success") {
          message.success(formData.isGuest ? "username avaialble" : "username and email available")
          resolve(response.data);
        }
        else {
          const errorMsg = response.data?.message || "User check failed.";
          message.error(errorMsg);
          reject(errorMsg);
        }
        // reject();
      }, usermaintoken, {}, (reason) => {
        //on fail
        setLoading(false);
      });
    })

  }
  const generateRandomPassword = (length = 8) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "!@#$";
    const all = letters + numbers + symbols;

    // Ensure at least one letter and one number
    const mandatory = [
      letters[Math.floor(Math.random() * letters.length)],
      numbers[Math.floor(Math.random() * numbers.length)],
    ];

    // Fill the rest randomly
    while (mandatory.length < length) {
      mandatory.push(all[Math.floor(Math.random() * all.length)]);
    }

    // Shuffle
    return mandatory.sort(() => Math.random() - 0.5).join("");
  };

  const isCreateMode = !userData; // null or undefined means create mode

  const copyPasswordToClipboard = () => {
    navigator.clipboard.writeText(formData.password);
    message.success("Password copied to clipboard!");
  }

  return (
    <div className="basic-info-tab">
      {isCreateMode ? (
        // CREATE MODE
        <Card title={<span><UserOutlined /> Create User</span>} style={{ marginBottom: 16 }}>
          {/* <Form layout="vertical" form={form}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Form.Item
                label="User Name"
                name="username"
                rules={[{ required: true, message: "User name is required" }]}
              >
                <Input prefix={<UserOutlined />} placeholder="Enter user name" />
              </Form.Item>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="First Name"
                    name="firstname"
                  >
                    <Input prefix={<UserOutlined />} placeholder="Enter first name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Last Name"
                    name="lastname"
                  >
                    <Input prefix={<UserOutlined />} placeholder="Enter last name" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label="Email Address"
                name="email"
                rules={[
                  { required: true, message: "Email is required" },
                  { type: "email", message: "Invalid email" }
                ]}
              >
                <Input prefix={<MailOutlined />} placeholder="Enter email address" />
              </Form.Item>


              <Form.Item style={{ textAlign: "right", marginTop: 24 }}>
                <Button loading={loading} type="primary" block onClick={handleContinue}>
                  Next
                </Button>
              </Form.Item>
            </Space>
          </Form> */}
          {/* <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Password is required" }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="Enter password" />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Confirm password is required" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Passwords do not match!"));
                    },
                  }),
                ]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="Confirm password" />
              </Form.Item> */}
          <Form layout="vertical" form={form}>
            <Space direction="vertical" style={{ width: "100%" }}>
              {/* Guest Toggle */}
              <Form.Item>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={formData.isGuest || false}
                      onChange={(e) => {
                        const isGuest = e.target.checked;
                        setFormData({
                          ...formData,
                          isGuest,
                          email: isGuest ? "" : formData.email,
                          password: isGuest ? generateRandomPassword() : "",
                        });
                        form.setFieldsValue({
                          email: "",
                          password: isGuest ? generateRandomPassword() : "",
                        });
                      }}
                    />{" "}
                    Create as Guest
                  </label>
                </div>
              </Form.Item>

              {
                formData.isGuest && <Alert message="Guest user is only valid for 7 days" type="info" showIcon />
              }
              <Form.Item
                label="User Name"
                name="username"
                rules={[{ required: true, message: "User name is required" },
                {
                  validator: (_, value) => {
                    if (!value || !/\s/.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("User name cannot contain spaces"));
                  },
                }]}
              >
                <Input prefix={<UserOutlined />} placeholder="Enter user name" />
              </Form.Item>
              {!formData.isGuest && (
                <>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item label="First Name" name="firstname">
                        <Input prefix={<UserOutlined />} placeholder="Enter first name" disabled={formData.isGuest} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Last Name" name="lastname">
                        <Input prefix={<UserOutlined />} placeholder="Enter last name" disabled={formData.isGuest} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      { required: true, message: "Email is required" },
                      { type: "email", message: "Invalid email" },
                    ]}
                  >
                    <Input prefix={<MailOutlined />} placeholder="Enter email address" />
                  </Form.Item>
                </>
              )}

              {/* <Form.Item label="Password" name="password">
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter password or generate"
                  value={formData.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                  disabled={formData.isGuest}
                />
              </Form.Item> */}

              {formData.isGuest && (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <span>Generated Login Password <Tag color="geekblue" icon={<ExclamationCircleOutlined />}><b><i>This password appears once only — please save it.</i></b></Tag> <span onClick={copyPasswordToClipboard}><h2 style={{ color: THEME_PALLETE.orange }}><b>{formData.password}</b>
                    <Button
                      type="link"
                      size="small"
                    // onClick={copyPasswordToClipboard}
                    >
                      <CopyOutlined />
                    </Button></h2></span></span>
                  <Space>
                    <Button
                      type="default"
                      size="small"
                      onClick={() => {
                        const newPass = generateRandomPassword();
                        setFormData({ ...formData, password: newPass });
                        form.setFieldsValue({ password: newPass });
                        message.info("New password generated!");
                      }}
                    >
                      Generate Again
                    </Button>
                  </Space>
                </div>
              )}

              {/* {!formData.isGuest && (
            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Confirm password is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Confirm password" />
            </Form.Item>
          )} */}

              <Form.Item style={{ textAlign: "right", marginTop: 24 }}>
                <Button loading={loading} type="primary" block onClick={handleContinue}>
                  Next
                </Button>
              </Form.Item>
            </Space>
          </Form>
        </Card >
      ) : (
        // EDIT MODE
        <>
          <Card title={<span><UserOutlined /> User Details</span>} style={{ marginBottom: 16 }}>
            <Form layout="vertical">
              <Space direction="vertical" style={{ width: "100%" }}>

                <Form.Item label="User Name" required>
                  <Input
                    prefix={<UserOutlined />}
                    type="username"
                    value={formData?.username || ""}
                    onChange={(e) => handleChange("username", e.target.value)}
                    placeholder="Enter user name"
                  />
                </Form.Item>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="First Name">
                      <Input
                        prefix={<UserOutlined />}
                        value={formData.firstname}
                        onChange={(e) =>
                          handleChange("firstname", e.target.value.split(" ")[0] || "")
                        }
                        placeholder="Enter first name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Last Name">
                      <Input
                        prefix={<UserOutlined />}
                        value={formData.lastname}
                        onChange={(e) =>
                          handleChange("lastname", e.target.value.split(" ")[0] || "")
                        }
                        placeholder="Enter last name"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item label="Email Address">
                  <Input
                    prefix={<MailOutlined />}
                    type="email"
                    value={formData.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                    placeholder="Enter email address"
                  />
                </Form.Item>
              </Space>
            </Form>
          </Card>

          <Card title={<span><KeyOutlined /> Security</span>}>
            <div className="security-section">
              <div>
                <h4>Authentication</h4>
                <p className="muted-text">Update the current user password</p>
                {/* <h4>Password Reset</h4>
                <p className="muted-text">Send a password reset email to the user</p> */}
              </div>
              <Button type="default" size="small" disabled={(userData?.enddate && userData.enddate !== "") || (!PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_USER, PermissionManager.PERMISSION_TYPE_EDIT) && (parentProps?.userdata?.user?.userid !== (userData?.userid || userData?.id)))} onClick={() => {
                // Trigger password change flow
                setShowUpdatePassword(true);
              }}>
                {/* Send Reset Email */}
                Change Password
              </Button>
            </div>
          </Card>
          <ChangePasswordModal
            visible={showUpdatePassword}
            onCancel={() => setShowUpdatePassword(false)}
            onComplete={() => setShowUpdatePassword(false)}
            user={{ ...userData, userid: userData.userid || userData.id }}
            usertoken={parentProps?.usermaintoken}
            requestServerPost={parentProps?.requestServerPost}
            successContent="Password for this user has been changed successfully."
            successOkText="OK"
          />
        </>
      )}
    </div >
  );
};

export default BasicInfoTab;
